import React from 'react';
import { Clock } from 'lucide-react';
import './QuizClock.css';

export default function QuizClock({ seconds }) {
  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };


  return (
    <div className={`timer-badge`}>
      <span className="timer-icon">
        <Clock size={16} strokeWidth={2.5} />
      </span>
      {/* 🌟 key={seconds} forces a CSS animation trigger cycle on every tick change */}
      <span key={seconds} className="timer-text ticking-animation">
        {formatTime(seconds)}
      </span>
    </div>
  );
}